module.exports = __webpack_public_path__ + "img/nutrition.b870417c.png";